"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeToDate = timeToDate;
exports.addMinutesToDate = addMinutesToDate;
exports.addRangeToPeriod = addRangeToPeriod;
exports.addRangeToPeriods = addRangeToPeriods;
exports.addRangeToSpans = addRangeToSpans;
/* eslint-disable require-jsdoc */
const _ = __importStar(require("lodash"));
const customParseFormat_1 = __importDefault(require("dayjs/plugin/customParseFormat"));
const dayjs_1 = __importDefault(require("dayjs"));
const isBetween_1 = __importDefault(require("dayjs/plugin/isBetween"));
dayjs_1.default.extend(customParseFormat_1.default);
dayjs_1.default.extend(isBetween_1.default);
function timeToDate(time) {
    return (0, dayjs_1.default)('1970.01.01 ' + time, 'YYYY.MM.DD HH:mm');
}
function addMinutesToDate(date, durationMinutes) {
    return date.add(durationMinutes, 'm');
}
function addRangeToPeriod(item) {
    return Object.assign({ start: timeToDate(item.time), end: addMinutesToDate(timeToDate(item.time), item.duration) }, item);
}
function addRangeToPeriods(array) {
    return _.map(array, addRangeToPeriod);
}
function addRangeToSpans(array) {
    return _.map(array, (item) => (Object.assign({ start: timeToDate(item.from), end: timeToDate(item.to) }, item)));
}
